import {applyOfficeLanguage} from '../i18n'; // Enabled i18n translations
import * as React from "react";
import {createRoot, Root} from "react-dom/client";
import App from "./App";

const root: Root = createRoot(document.getElementById("container"));

Office.onReady()
    .then(async info => {
        console.info(`Initialized app. (host: ${info.host} platform: ${info.platform})`);
        await applyOfficeLanguage();
        root.render(<App/>);
    });

if ((module as any).hot) { // Perform hot reloads if enabled
    (module as any).hot.accept("./App", () => root.render(require("./App").default));
}
